<template>
    <div class="chat-input">
        <div class="chat-input__field">
            <textarea
                ref="textareaRef"
                v-model="inputText"
                class="chat-input__textarea"
                :disabled="disabled"
                :placeholder="t('chat.input.placeholder')"
                rows="2"
                @input="autoGrow"
                @keydown.enter.exact.prevent="onSend"
            />
            <nw-btn
                v-if="isStreaming"
                icon="stop"
                small
                :title="t('chat.input.stop')"
                @click="emit('abort')"
            />
            <nw-btn
                v-else
                :disabled="disabled || !inputText.trim()"
                icon="send"
                small
                @click="onSend"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

defineOptions({
    name: 'ChatInput',
});

const props = defineProps<{
    disabled?: boolean;
    isStreaming?: boolean;
}>();

const emit = defineEmits<{ send: [prompt: string]; abort: [] }>();

const { t } = useI18n();

const inputText = ref('');
const textareaRef = ref<HTMLTextAreaElement>();

function autoGrow(): void {
    const el = textareaRef.value;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
}

function onSend(): void {
    const text = inputText.value.trim();
    if (!text || props.disabled) return;
    emit('send', text);
    inputText.value = '';
    if (textareaRef.value) textareaRef.value.style.height = 'auto';
}
</script>
